import type { HTMLAttributes } from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

/**
 * A skeleton bar standing in for one line of text (NEWS-26). It sits on an
 * invisible line in the parent's font, so the slot is exactly as tall as the
 * loaded text and nothing moves when the value arrives. Put it inside an
 * element with the loaded text's font classes; props go to the bar.
 */
export function LineSkeleton({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className="relative">
      <span aria-hidden="true" className="invisible">
        0
      </span>
      <Skeleton
        className={cn('absolute left-0 top-1/2 -translate-y-1/2', className)}
        {...props}
      />
    </div>
  );
}
